var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mb-0" }, [
    _c("label", { staticClass: "form-group-label" }, [
      _vm._v(_vm._s(_vm.translate.user_features.date_of_birth))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex g-2" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.month,
              expression: "month"
            }
          ],
          staticClass: "form-control mr-2 text-capitalize",
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.month = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        [
          _c(
            "option",
            { attrs: { hidden: "", disabled: "" }, domProps: { value: null } },
            [_vm._v(_vm._s(_vm.translate.product.month))]
          ),
          _vm._v(" "),
          _vm._l(12, function(month) {
            return _c("option", { domProps: { value: month } }, [
              _vm._v(_vm._s(month))
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.year,
              expression: "year"
            }
          ],
          staticClass: "form-control text-capitalize",
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.year = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        [
          _c(
            "option",
            { attrs: { hidden: "", disabled: "" }, domProps: { value: null } },
            [_vm._v(_vm._s(_vm.translate.product.year))]
          ),
          _vm._v(" "),
          _vm._l(_vm.generateYears(), function(year) {
            return _c("option", { domProps: { value: year } }, [
              _vm._v(_vm._s(year))
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82d4daa4", { render: render, staticRenderFns: staticRenderFns })
  }
}